import script from "./leaves-employee-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./leaves-employee-modal.vue?vue&type=script&setup=true&lang=js"

import "./leaves-employee-modal.vue?vue&type=style&index=0&id=22ad3d50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ad3d50"]])

export default __exports__